<template>
  <div class="mayday-root" :class="{ 'is-act-ended': isActEnded }">
    <div class="custom-nav-block" :class="[scrollTop ? 'nav-scrolling' : 'nav-default']" :style="`padding-top:${topBarHeight}px`">
      <van-nav-bar class="van-bar" left-arrow @click-left="closeWeb" @click-right="handleToRule">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow12.webp" alt="" />
        </template>
        <template #right>
          <img class="right-nav" src="@/assets/packageAssets/common/rules03.webp" alt="" />
        </template>
      </van-nav-bar>
    </div>

    <div class="mayday-main" :style="{ 'margin-top': !isActEnded ? `-${topBarHeight + 46}px` : '10px' }">
      <div v-if="!isActEnded" class="mayday-hero" :style="{ 'padding-top': `${topBarHeight + 46}px` }">
        <p class="hero-sub">{{ $t('lang.WorldCup.k001') }}</p>
        <p class="hero-title">{{ $t('lang.WorldCup.k114') }}</p>
        <div class="hero-prize">
          <span class="hero-prize-num">{{ $t('lang.WorldCup.k115') }}</span>
          <img class="hero-prize-coin" :src="getMatchImg('beans')" alt="" />
        </div>
        <div class="hero-countdown">
          <img class="hero-cd-icon" src="./images/clock.webp" alt="" />
          <div class="cd-cell">
            <span class="cd-val">{{ countdownObj.countdownResult.days }}</span>
            <span class="cd-unit">{{ $t('lang.WorldCup.k089') }}</span>
          </div>
          <span class="cd-colon">:</span>
          <div class="cd-cell">
            <span class="cd-val">{{ countdownObj.countdownResult.hours }}</span>
            <span class="cd-unit">{{ $t('lang.ActCommon.k060') }}</span>
          </div>
          <span class="cd-colon">:</span>
          <div class="cd-cell">
            <span class="cd-val">{{ countdownObj.countdownResult.minutes }}</span>
            <span class="cd-unit">{{ $t('lang.ActCommon.k061') }}</span>
          </div>
          <span class="cd-colon">:</span>
          <div class="cd-cell">
            <span class="cd-val">{{ countdownObj.countdownResult.seconds }}</span>
            <span class="cd-unit">{{ $t('lang.ActCommon.k062') }}</span>
          </div>
        </div>
      </div>

      <div class="mayday-scroll">
        <div v-if="!isActEnded" class="segment-tabs">
          <div class="segment-inner">
            <div class="segment-item" :class="{ 'segment-active': mainSegment === 'progress' }" @click="switchPage('progress')">
              {{ $t('lang.WorldCup.k030') }}
            </div>
            <div class="segment-item" :class="{ 'segment-active': mainSegment === 'rank' }" @click="switchPage('rank')">
              {{ $t('lang.WorldCup.k031') }}
            </div>
          </div>
        </div>

        <div v-show="!isActEnded && mainSegment === 'progress'" ref="progressAnchor" class="mayday-progress-segment">
          <div class="card milestone-card">
            <div v-if="actInfo" class="points-rank">
              <div class="pr-item">
                <div class="pr-label">{{ $t('lang.WorldCup.k083') }}</div>
                <div class="pr-value">{{ actInfo.score || 0 }}</div>
              </div>
              <div class="pr-gap"></div>
              <div class="pr-item">
                <div class="pr-label">{{ $t('lang.WorldCup.k084') }}</div>
                <div class="pr-value">{{ milestoneRankDisplay }}</div>
              </div>
            </div>
            <div class="card-head">
              <div class="card-head-left">{{ $t('lang.WorldCup.k081') }}</div>
            </div>
            <div v-if="milestoneClaimBanner" class="milestone-claim-banner" @click="handleClaim()">
              <div class="mcb-label">{{ milestoneClaimBannerLabel }}</div>
              <div class="mcb-reward">
                +{{ milestoneClaimBanner.beans }}
                <img :src="getMatchImg('beans')" alt="" />
              </div>
            </div>
            <div v-if="milestoneProgressLine" class="milestone-progress-line">
              <span class="mpl-label">{{ $t('lang.ActCommon.k016') }}:</span>
              <span class="mpl-cur">{{ milestoneProgressLine.current }}</span>
              <span class="mpl-rest">/ {{ milestoneProgressLine.target }} {{ $t('lang.WorldCup.k088') }}</span>
            </div>
            <div class="card-body">
              <div v-if="actInfo && actInfo.milestoneStates" class="part-percent">
                <div class="progress-box">
                  <div v-for="(node, idx) in visibleMilestoneNodes" :key="`${node.index}-${idx}`">
                    <div class="box-top" :style="{ opacity: getMilestoneState(node) === 2 ? 0.5 : 1 }">
                      <!-- prettier-ignore -->
                      <div>
                    +{{ node.beans }}<img :src="getMatchImg('beans')">
                  </div>
                    </div>
                    <img v-if="getMilestoneState(node) === 2" class="box" src="./images/box-open.webp" />
                    <img v-else-if="getMilestoneState(node) === 1" class="box sharking" src="./images/box.webp" />
                    <img v-else class="box" src="./images/box.webp" />
                  </div>
                </div>
                <div class="progress-wraper">
                  <div class="progress-bar">
                    <div class="step step0" :class="{ on: visibleMilestoneNodes[0] && getMilestoneState(visibleMilestoneNodes[0]) > 0 }"></div>
                    <div class="step step1" :class="{ on: visibleMilestoneNodes[1] && getMilestoneState(visibleMilestoneNodes[1]) > 0 }"></div>
                    <img v-if="showMilestoneProgressDot" class="progress-dot" src="./images/dot.webp" alt="" />
                    <div class="step step5" :class="{ on: visibleMilestoneNodes[2] && getMilestoneState(visibleMilestoneNodes[2]) > 0 }"></div>
                    <div class="progress-trace" :style="{ width: mePosition1 }">
                      <div v-if="mePosition1 !== '100%'" class="me"></div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="btn-default">
                <div v-if="milestoneClaimStatus === 'singleClaim'" class="real-btn" @click="handleClaim()">
                  {{ $t('lang.ActCommon.k086') }}
                </div>
                <div v-if="milestoneClaimStatus === 'multiClaim'" class="real-btn" @click="handleClaim()">
                  {{ $t('lang.ActCommon.k084') }}
                </div>
                <div v-if="milestoneClaimStatus === 'canNotClaim'" class="real-btn btn-disable">
                  {{ $t('lang.ActCommon.k085') }}
                </div>
                <div v-if="milestoneClaimStatus === 'claimed'" class="real-btn btn-disable">
                  {{ $t('lang.ActCommon.k087') }}
                </div>
              </div>
            </div>
          </div>

          <div class="card earn-card">
            <div class="earn-card-body">
              <div class="earn-title">{{ $t('lang.WorldCup.k080') }}</div>
              <div class="earn-list">
                <div v-for="item in earnPointItems" :key="item.id" class="earn-item">
                  <div class="earn-item-main">
                    <div class="earn-item-title">{{ $t(item.titleKey) }}</div>
                    <div class="earn-item-desc">{{ $t('lang.WorldCup.k113') }}</div>
                  </div>
                  <div class="earn-item-badge">+{{ item.points }} {{ $t(item.pointKey) }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <act-female-rank v-if="isActEnded || mainSegment === 'rank'" @go-earn="onGoEarnFromRank" />
      </div>
    </div>

    <!-- 奖励弹窗 -->
    <div v-if="showReward" class="mask">
      <div class="dia-con">
        <div class="dia-tit">
          <span>{{ $t('lang.ActCommon.k089') }}!</span>
        </div>

        <div class="reward-item">
          <span>+{{ reward }}</span>
          <img :src="getMatchImg('beans')" alt="" />
        </div>

        <div class="dia-btn" @click="showReward = false">{{ $t('lang.ActCommon.k100') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { normalActBaseInfo, normalActRank, normalMilesClaim } from './apidir/api.js'

import CountDownClass from '@/utils/count-down.js'
import scrollMixin from '@/hooks/scroll.mixin.js'
import ActFemaleRank from './actFemaleRank.vue'

export default {
  mixins: [scrollMixin],
  components: {
    ActFemaleRank,
  },
  data() {
    return {
      mainSegment: 'progress',
      actInfo: null,
      countdownObj: null,
      packageName: '',
      boardData: {
        num1Reward: 0,
        num2Reward: 0,
        num3Reward: 0,
        num4Reward: 0,
      },
      mePosition1: '7%',

      // bar
      prize1: {},
      prize2: {},
      prize3: {},

      // reward
      showReward: false,
      reward: 0,

      // 其他
      loading: false,

      earnPointItems: [
        { id: 'match', titleKey: 'lang.WorldCup.k111', points: 1, pointKey: 'lang.WorldCup.k109' },
        { id: 'private', titleKey: 'lang.WorldCup.k112', points: 3, pointKey: 'lang.WorldCup.k110' },
      ],
    }
  },
  computed: {
    isActEnded() {
      if (!this.actInfo) return false
      if (Number(this.actInfo.countdown) <= 0) return true
      const cr = this.countdownObj && this.countdownObj.countdownResult
      if (cr && cr.days === '00' && cr.hours === '00' && cr.minutes === '00' && cr.seconds === '00') {
        return true
      }
      return false
    },
    milestoneRankDisplay() {
      if (!this.actInfo) return '--'
      const score = Number(this.actInfo.score)
      if (!Number.isFinite(score) || score < 3) return '--'
      const r = this.actInfo.rank
      if (r == null || r === '' || r === '--') return '--'
      const n = Number(r)
      if (!Number.isFinite(n) || n < 1) return '--'
      if (n > 100) return '100+'
      return String(n)
    },
    milestoneClaimStatus() {
      const states = this.actInfo && this.actInfo.milestoneStates
      if (!states || !states.length) return 'canNotClaim'

      if (states.every((item) => Number(item.state) === 2)) {
        return 'claimed'
      }

      const claimableCount = states.filter((item) => Number(item.state) === 1).length
      if (claimableCount === 1) return 'singleClaim'
      if (claimableCount > 1) return 'multiClaim'
      return 'canNotClaim'
    },
    milestoneClaimBanner() {
      const states = this.actInfo && this.actInfo.milestoneStates
      if (!states || !states.length) return null

      const claimable = states.filter((s) => Number(s.state) === 1)
      if (claimable.length) {
        return {
          mode: 'claimable',
          beans: claimable.reduce((sum, s) => sum + Number(s.beans || 0), 0),
        }
      }

      const next = states.find((s) => Number(s.state) === 0)
      if (!next) return null

      return {
        mode: 'next',
        beans: Number(next.beans || 0),
      }
    },
    milestoneClaimBannerLabel() {
      const banner = this.milestoneClaimBanner
      if (!banner) return ''
      return banner.mode === 'claimable' ? this.$t('lang.WorldCup.k025') : this.$t('lang.WorldCup.k116')
    },
    milestoneProgressLine() {
      const states = this.actInfo && this.actInfo.milestoneStates
      if (!states || !states.length) return null
      const score = Number(this.actInfo.score)
      if (!Number.isFinite(score)) return null

      let prevPoints = 0
      let nextPoints = null
      for (let i = 0; i < states.length; i++) {
        const pts = Number(states[i].points)
        if (!Number.isFinite(pts)) continue
        if (score < pts) {
          nextPoints = pts
          break
        }
        prevPoints = pts
      }
      if (nextPoints == null) return null

      return {
        current: Math.max(0, score - prevPoints),
        target: nextPoints - prevPoints,
      }
    },
    visibleMilestoneNodes() {
      const states = this.actInfo && this.actInfo.milestoneStates
      if (!states || !states.length) return []
      return this.getVisibleMilestoneIndices(states).map((index) => ({
        index,
        ...states[index],
      }))
    },
    showMilestoneProgressDot() {
      const nodes = this.visibleMilestoneNodes
      if (nodes.length < 3) return false
      return nodes[2].index - nodes[1].index > 1
    },
  },
  methods: {
    getMilestoneState(node) {
      return Number(node && node.state)
    },
    getVisibleMilestoneIndices(states) {
      if (!states || !states.length) return []
      const lastIdx = states.length - 1
      if (states.length < 3) {
        return [0, 1, lastIdx]
      }

      const windowStart = lastIdx - 2
      const firstClaimableIdx = states.findIndex((item) => this.getMilestoneState(item) === 1)
      const lastClaimedIdx = states.reduce((acc, item, i) => (this.getMilestoneState(item) === 2 ? i : acc), -1)

      if (firstClaimableIdx === -1 && lastClaimedIdx === lastIdx) {
        return [windowStart, lastIdx - 1, lastIdx]
      }

      let leftIdx
      let middleIdx

      if (firstClaimableIdx !== -1) {
        leftIdx = firstClaimableIdx
        const nextUnreachedIdx = states.findIndex((item, i) => i > leftIdx && this.getMilestoneState(item) === 0)
        middleIdx = nextUnreachedIdx !== -1 ? nextUnreachedIdx : Math.min(leftIdx + 1, lastIdx - 1)
      } else if (lastClaimedIdx !== -1) {
        leftIdx = lastClaimedIdx
        const nextUnreachedIdx = states.findIndex((item, i) => i > leftIdx && this.getMilestoneState(item) === 0)
        middleIdx = nextUnreachedIdx !== -1 ? nextUnreachedIdx : Math.min(leftIdx + 1, lastIdx - 1)
      } else {
        leftIdx = 0
        middleIdx = 1
      }

      if (leftIdx >= windowStart) {
        return [windowStart, lastIdx - 1, lastIdx]
      }

      if (leftIdx >= middleIdx) {
        middleIdx = Math.min(leftIdx + 1, lastIdx - 1)
      }
      if (middleIdx >= lastIdx) {
        middleIdx = lastIdx - 1
      }

      return [leftIdx, middleIdx, lastIdx]
    },
    updateMePosition(states) {
      const [leftIdx, middleIdx, rightIdx] = this.getVisibleMilestoneIndices(states)
      const n0 = states[leftIdx]
      const n1 = states[middleIdx]
      const n2 = states[rightIdx]

      if (!n0 || !n1 || !n2) {
        this.mePosition1 = '7%'
        return
      }

      const s0 = this.getMilestoneState(n0)
      const s1 = this.getMilestoneState(n1)
      const s2 = this.getMilestoneState(n2)

      if (middleIdx === rightIdx) {
        if (s0 === 0 && s2 === 0) {
          this.mePosition1 = '7%'
        } else if (s0 === 1) {
          this.mePosition1 = '12.6%'
        } else if (s0 === 2 && s2 === 0) {
          this.mePosition1 = '75%'
        } else if (s2 === 1 || s2 === 2) {
          this.mePosition1 = '100%'
        } else {
          this.mePosition1 = '7%'
        }
        return
      }

      if (s0 === 0 && s1 === 0 && s2 === 0) {
        this.mePosition1 = '7%'
      } else if (s0 === 1) {
        this.mePosition1 = '12.6%'
      } else if (s0 === 2 && s1 === 0) {
        this.mePosition1 = '35%'
      } else if (s1 === 1) {
        this.mePosition1 = '55%'
      } else if (s1 === 2 && s2 === 0) {
        this.mePosition1 = '75%'
      } else if (s2 === 1 || s2 === 2) {
        this.mePosition1 = '100%'
      } else {
        this.mePosition1 = '7%'
      }
    },
    switchPage(arg) {
      this.mainSegment = arg
    },
    scrollProgressSectionIntoView() {
      const el = this.$refs.progressAnchor
      if (!el || typeof el.getBoundingClientRect !== 'function') return
      const rect = el.getBoundingClientRect()
      if (!rect.width && !rect.height) return
      const cur = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
      const top = Math.max(0, rect.top + cur - 8)
      if (typeof window.scrollTo === 'function') {
        try {
          window.scrollTo({ left: 0, top, behavior: 'auto' })
        } catch (e) {
          window.scrollTo(0, top)
        }
      }
      document.documentElement.scrollTop = top
      document.body.scrollTop = top
    },
    onGoEarnFromRank() {
      if (this.isActEnded) return
      this.mainSegment = 'progress'
      this.$nextTick(() => {
        this.$nextTick(() => {
          window.requestAnimationFrame(() => {
            window.requestAnimationFrame(() => {
              this.scrollProgressSectionIntoView()
            })
          })
        })
      })
    },
    handleToRule() {
      this.$router.push({ path: '/worldcup-rules-female', query: { from: 'worldcup-main-female' } })
    },
    handleToRank() {
      this.$router.push({ path: '/worldcup-rank-female', query: { from: 'worldcup-main-female' } })
    },
    handleReplaceToRank() {
      this.$router.replace({ path: '/worldcup-rank-female' })
    },
    handleClaim() {
      if (this.actInfo.milestoneStates && this.actInfo.milestoneStates.length) {
        if (this.actInfo.milestoneStates.some((item) => Number(item.state) === 1)) {
          if (this.loading) {
            return
          }
          this.loading = true

          normalMilesClaim()
            .then((resData) => {
              if (resData && !resData.error) {
                this.showReward = true
                this.reward = resData.data
                this.fetchBaseData()
              }
            })
            .finally(() => {
              this.loading = false
            })
        }
      }
    },
    fetchBaseData() {
      normalActBaseInfo().then((resData) => {
        if (resData && !resData.error) {
          this.actInfo = resData || null

          if (!this.actInfo) return

          if (this.actInfo.countdown <= 0) {
            this.mainSegment = 'rank'
            return
          }

          if (this.actInfo.endTimestamp) {
            if (this.countdownObj && this.countdownObj.animationFrameId) {
              cancelAnimationFrame(this.countdownObj.animationFrameId)
              this.countdownObj.animationFrameId = null
            }
            this.countdownObj.initCountDown(this.actInfo.endTimestamp, 'DHMS', true)
          }

          if (this.actInfo.leaderboardRewards && this.actInfo.leaderboardRewards.length) {
            this.boardData.num1Reward = this.actInfo.leaderboardRewards[0] || 0
            this.boardData.num2Reward = this.actInfo.leaderboardRewards[1] || 0
            this.boardData.num3Reward = this.actInfo.leaderboardRewards[2] || 0
            this.boardData.num4Reward = this.actInfo.leaderboardRewards[3] || 0
          }

          if (!this.actInfo.milestoneStates && this.actInfo.milestoneRewards) {
            this.actInfo.milestoneStates = this.actInfo.milestoneRewards
          }

          if (this.actInfo.milestoneStates && this.actInfo.milestoneStates.length === 6) {
            this.updateMePosition(this.actInfo.milestoneStates)
          }
        }
      })

      normalActRank().then((resData) => {
        if (resData && !resData.error) {
          if (resData.ranks && resData.ranks.length > 0) {
            this.prize1 = resData.ranks[0] || {}
            this.prize2 = resData.ranks[1] || {}
            this.prize3 = resData.ranks[2] || {}
          }
          if (resData.owners && this.actInfo) {
            this.actInfo.rank = resData.owners.rank
          }
        }
      })
    },
  },
  created() {
    this.countdownObj = new CountDownClass()
    this.fetchBaseData()
  },
  beforeDestroy() {
    if (this.countdownObj && this.countdownObj.animationFrameId) {
      cancelAnimationFrame(this.countdownObj.animationFrameId)
    }
  },
}
</script>

<style lang="less" scoped>
img:not([src]) {
  opacity: 0;
}

.mayday-root {
  position: relative;
  width: 100%;
  min-height: 100vh;
  overflow-x: hidden;
  background: #3a4fff;

  &.is-act-ended {
    .mayday-scroll {
      padding-top: 8px;
    }
  }

  .custom-nav-block {
    ::v-deep .van-bar.van-nav-bar {
      background: transparent;
    }
    ::v-deep .van-bar .van-icon {
      color: #fff;
    }
  }

  .nav-default {
    background: transparent;
  }

  .nav-scrolling {
    background: #3a4fff;
  }

  .left-nav,
  .right-nav {
    width: 24px;
    height: 24px;
    display: block;
  }

  .mayday-main {
    position: relative;

    .mayday-hero {
      width: 100%;
      aspect-ratio: 750 / 666;
      background: url(./images/main-bg.webp) top left / 100% 100% no-repeat;
      position: relative;
      z-index: 2;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 0 0 12px;

      .hero-sub {
        margin: 0;
        font-family: 'TikTokSans-Bold';
        font-weight: 900;
        font-size: 16px;
        line-height: 20px;
        color: #fff;
      }

      .hero-title {
        font-family: 'TikTokSans-Bold';
        font-weight: 900;
        font-size: 40px;
        line-height: 52px;
        text-align: center;
        color: #fff;
        text-shadow: 0 4px 0 rgba(0, 32, 63, 0.7);
        max-width: 340px;
      }

      .hero-prize {
        display: flex;
        align-items: center;
        gap: 12px;
        padding-left: 16px;

        .hero-prize-num {
          font-family: 'TikTokSans-Bold';
          font-weight: 900;
          font-size: 60px;
          line-height: 78px;
          color: #ffffff;
          text-shadow: 0 4px 0 rgba(0, 32, 63, 0.7);
        }

        .hero-prize-coin {
          width: 40px;
          height: 40px;
          object-fit: contain;
        }
      }

      .hero-countdown {
        margin-top: 14px;
        display: flex;
        align-items: center;
        padding: 6px 12px;
        border-radius: 20px;
        border: 0.5px solid rgba(255, 255, 255, 0.5);
        background: rgba(62, 160, 56, 0.92);

        .hero-cd-icon {
          width: 20px;
          height: 20px;
          margin-right: 2px;
        }

        .cd-cell {
          flex: 1 1 0;
          min-width: 40px;
          flex-shrink: 1;
          display: flex;
          align-items: flex-end;
          justify-content: center;
          flex-wrap: nowrap;
          gap: 0;
          padding: 4px 4px;
          box-sizing: border-box;
          border-radius: 4px;
          white-space: nowrap;

          .cd-val {
            font-family: 'TikTokSans-Bold';
            font-weight: 800;
            font-size: 16px;
            color: #ffffff;
          }

          .cd-unit {
            font-family: 'TikTokSans-Bold';
            font-weight: 700;
            font-size: 11px;
            line-height: 16px;
            color: #ffffff;
          }
        }

        .cd-colon {
          flex-shrink: 0;
          color: #fff;
          font-weight: 700;
          font-size: 14px;
          margin: 0 3px;
        }
      }
    }

    .mayday-scroll {
      position: relative;
      z-index: 3;
      padding: 0 10px 48px;
      box-sizing: border-box;

      .segment-tabs {
        display: flex;
        justify-content: center;
        padding: 12px 2px 16px;
        box-sizing: border-box;

        .segment-inner {
          display: flex;
          align-items: center;
          width: 100%;
          max-width: 355px;
          padding: 6px;
          border-radius: 60px;
          background: #2735a6;
          backdrop-filter: blur(11.75px);
          box-sizing: border-box;

          .segment-item {
            flex: 1;
            min-width: 0;
            padding: 5px 16px;
            border-radius: 20px;
            font-family: 'TikTokSans-Bold';
            font-weight: 800;
            font-size: 16px;
            line-height: 21px;
            text-align: center;
            color: rgba(255, 255, 255, 0.8);
            &.segment-active {
              background: #fff;
              color: #000000;
            }
          }
        }
      }

      .card {
        width: 355px;
        max-width: 100%;
        margin: 0 auto 16px;
        border-radius: 20px;
        border: 2px solid #fff;
        background: #fff;
        box-sizing: border-box;
      }

      .card-head {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 16px;

        .card-head-left {
          display: flex;
          align-items: center;
          gap: 8px;
          font-family: 'TikTokSans-Bold';
          font-weight: 900;
          font-style: italic;
          font-size: 20px;
          line-height: 24px;
          color: #000000;
        }
      }

      .card-tips {
        margin: 0;
        padding: 0 16px 12px;
        font-family: 'TikTokSans-Regular';
        font-size: 15px;
        line-height: 22px;
        color: #64748b;
        font-weight: 400;
      }

      .card-body {
        padding: 0 0 16px;
      }

      .earn-card {
        .earn-card-body {
          padding: 16px 16px 0;
          box-sizing: border-box;
        }

        .earn-title {
          color: #000;
          font-family: 'TikTokSans-Bold';
          font-size: 20px;
          font-style: italic;
          font-weight: 900;
          line-height: 24px;
        }

        .earn-list {
          display: flex;
          flex-direction: column;
        }

        .earn-item {
          padding: 16px 0;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 12px;
        }

        .earn-item-main {
          flex: 1;
          min-width: 0;
        }

        .earn-item-title {
          color: #000;
          font-family: 'TikTokSans-Bold';
          font-size: 16px;
          font-weight: 700;
          line-height: 21px;
        }

        .earn-item-desc {
          margin-top: 4px;
          color: #8e9092;
          font-family: 'TikTokSans-Regular';
          font-size: 12px;
          font-weight: 500;
          line-height: 16px;
        }

        .earn-item-badge {
          flex-shrink: 0;
          display: flex;
          padding: 8px 12px;
          justify-content: center;
          align-items: center;
          gap: 10px;
          border-radius: 17px;
          background: #e9ffe7;
          box-sizing: border-box;
          color: #04823b;
          font-family: 'TikTokSans-Bold';
          font-size: 14px;
          font-style: normal;
          font-weight: 600;
          line-height: normal;
          text-transform: capitalize;
          white-space: nowrap;
        }
      }

      .milestone-card {
        .milestone-claim-banner {
          margin: 0 16px 12px;
          padding: 16px 12px;
          border-radius: 8px;
          background: linear-gradient(278deg, #22f7e5 1.83%, #80ff59 98.56%);
          text-align: center;
          box-sizing: border-box;
          cursor: pointer;

          .mcb-label {
            color: #000;
            font-family: 'TikTokSans-Bold';
            font-size: 14px;
            font-style: normal;
            font-weight: 600;
            line-height: normal;
          }

          .mcb-reward {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 4px;
            margin: 8px 0 0;
            color: var(--fg-text-primary, #202326);
            font-family: 'TikTokSans-Bold';
            font-size: 42px;
            font-style: normal;
            font-weight: 800;
            line-height: normal;

            img {
              width: 32px;
              height: 32px;
              object-fit: contain;
              flex-shrink: 0;
            }
          }
        }

        .milestone-progress-line {
          margin: 16px 16px;
          font-family: 'TikTokSans-Regular';
          font-size: 14px;
          font-style: normal;
          font-weight: 500;
          line-height: normal;

          .mpl-label,
          .mpl-rest {
            color: #000;
          }

          .mpl-cur {
            color: #1bb55e;
          }
        }

        .points-rank {
          display: flex;
          align-items: stretch;
          justify-content: center;
          gap: 0;
          padding: 12px 16px 0;
          box-sizing: border-box;

          .pr-gap {
            width: 12px;
            flex-shrink: 0;
          }

          .pr-item {
            flex: 1;
            min-width: 0;
            min-height: 82px;
            padding: 0 12px;
            border-radius: 12px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            box-sizing: border-box;
            background: url(./images/point-rank-card.webp) top left / 100% 100% no-repeat;

            .pr-label {
              font-family: 'TikTokSans-Regular';
              font-weight: 400;
              font-size: 14px;
              line-height: 18px;
              color: #0b0d0c;
              text-align: center;
            }

            .pr-value {
              margin-top: 4px;
              font-family: 'TikTokSans-Bold';
              font-weight: 800;
              font-size: 32px;
              line-height: 36px;
              color: #0b0d0c;
              text-align: center;
              max-width: 100%;
              word-wrap: break-word;
            }
          }
        }

        .part-percent {
          width: 100%;
          padding: 0 16px 0;
          box-sizing: border-box;
          overflow: hidden;
          .progress-box {
            width: 100%;
            max-width: 300px;
            margin: 0 auto;
            display: flex;
            align-items: center;
            > div {
              display: flex;
              flex-direction: column;
              .box-top {
                min-width: 52px;
                min-height: 31px;
                padding: 0 5px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                background: url(./images/tip-wrap.webp) left top / 100% 100% no-repeat;
                > div {
                  color: #000000;
                  font-family: 'TikTokSans-Regular';
                  font-size: 15px;
                  font-style: normal;
                  font-weight: 700;
                  line-height: 20px;
                  padding-bottom: 5px;
                }
                img {
                  width: 14px;
                  margin: 0 2px;
                }
              }
              .box {
                width: 34px;
              }
              &:nth-child(1) {
                display: flex;
                align-items: center;
                justify-content: center;
                transform: translateX(10px);
              }
              &:nth-child(2) {
                flex: 1;
                display: flex;
                align-items: center;
                justify-content: center;
                transform: translateX(8px);
              }
              &:nth-child(3) {
                display: flex;
                align-items: center;
                justify-content: flex-end;
                transform: translateX(8px);
              }
            }
          }
          .progress-wraper {
            width: 100%;
            max-width: 286px;
            height: 20px;
            margin: 5px auto 0;
            display: flex;
            align-items: center;
            overflow: hidden;
            .progress-bar {
              width: 100%;
              height: 8px;
              border-radius: 100px;
              background: #c2ffce;
              display: flex;
              align-items: center;
              justify-content: flex-start;
              position: relative;
              overflow: hidden;

              .step {
                width: 14px;
                height: 14px;
                border-radius: 12px;
                border-radius: 12px;
                border: 2px solid #fff;
                background: #c2ffce;
                position: absolute;
                top: 50%;
                margin-top: -7px;
                z-index: 9;
                &.on {
                  border: 2px solid #fff;
                  background: #21ea57;
                }
              }
              .step0 {
                left: 36px;
              }
              .step1 {
                left: calc(50% + 18px);
                margin-left: -7px;
              }
              .step5 {
                left: 100%;
                margin-left: -7px;
              }

              .progress-dot {
                position: absolute;
                top: 50%;
                left: calc(75% + 11px);
                z-index: 8;
                height: 9px;
                width: 18px;
                transform: translate(-50%, -50%);
                pointer-events: none;
              }

              .progress-trace {
                width: 20px;
                height: 100%;
                border-radius: 100px;
                background: linear-gradient(90deg, #c9ffaa 0%, #21ea57 73.57%);
                position: relative;
                overflow: hidden;
                .me {
                  position: absolute;
                  top: 50%;
                  right: 0;
                  z-index: 99;
                  width: 31px;
                  height: 20px;
                  transform: translate(50%, -50%);
                  background: url(./images/progress-me.webp) left top / 100% 100% no-repeat;
                }
              }
            }
          }
        }
      }

      .milestone-card .btn-default {
        display: flex;
        flex-direction: column;
        align-items: stretch;
        width: 100%;
        margin: 36px auto 8px;
        padding: 0 16px;
        box-sizing: border-box;

        .real-btn {
          display: flex;
          height: 52px;
          padding: 17px 50px;
          justify-content: center;
          align-items: center;
          align-self: stretch;
          box-sizing: border-box;
          border: none;
          border-radius: 12px;
          background: #21ea57;
          color: #000;
          text-align: center;
          font-family: 'TikTokSans-Bold';
          font-size: 20px;
          font-style: normal;
          font-weight: 700;
          line-height: normal;
          cursor: pointer;

          &.btn-disable {
            border-radius: 12px;
            background: #d5ecdb;
            color: #90ab97;
            cursor: default;
          }
        }
      }
    }
  }

  .mask {
    position: fixed;
    inset: 0;
    z-index: 999;
    background: rgba(0, 0, 0, 0.7);
    overflow-y: auto;
    overflow-x: hidden;

    display: flex;
    align-items: center;
    justify-content: center;

    .dia-con {
      width: 315px;
      max-width: calc(100% - 32px);
      padding: 24px 20px 20px;
      border-radius: 16px;
      background: #242e80;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      align-items: center;

      .dia-tit {
        color: #fff;
        text-align: center;
        font-family: 'TikTokSans-Bold';
        font-size: 20px;
        font-style: normal;
        font-weight: 800;
        line-height: normal;
      }

      .reward-item {
        margin-top: 24px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 4px;

        img {
          width: 32px;
          height: 32px;
          object-fit: contain;
        }

        span {
          color: #fff;
          text-align: center;
          font-family: 'TikTokSans-Regular';
          font-size: 20px;
          font-style: normal;
          font-weight: 800;
          line-height: normal;
        }
      }

      .dia-btn {
        display: flex;
        width: 275px;
        max-width: 100%;
        height: 52px;
        margin-top: 24px;
        padding: 10px;
        justify-content: center;
        align-items: center;
        gap: 10px;
        box-sizing: border-box;
        border: none;
        border-radius: 30px;
        background: #21ea57;
        color: #000;
        text-align: center;
        font-family: 'TikTok Sans', 'TikTokSans-Bold', sans-serif;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        cursor: pointer;
      }
    }
  }
}

@keyframes shake {
  0% {
    transform: rotate(0deg);
  }
  25% {
    transform: rotate(-10deg);
  }
  50% {
    transform: rotate(0deg);
  }
  75% {
    transform: rotate(10deg);
  }
  100% {
    transform: rotate(0deg);
  }
}

html[lang='ar'],
html[lang='fa'],
html[lang='he'] {
  .mayday-root {
    .mayday-main {
      .mayday-scroll {
        .milestone-card {
          .part-percent {
            .progress-box {
              > div {
                &:nth-child(1) {
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  transform: translateX(-10px);
                }
                &:nth-child(2) {
                  flex: 1;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  transform: translateX(-8px);
                }
                &:nth-child(3) {
                  display: flex;
                  align-items: center;
                  justify-content: flex-end;
                  transform: translateX(-8px);
                }
              }
            }
            .progress-wraper {
              .progress-bar {
                .step0 {
                  left: unset;
                  right: 36px;
                }
                .step1 {
                  left: unset;
                  right: calc(50% + 18px);
                  margin-right: -7px;
                }
                .step5 {
                  left: unset;
                  right: 100%;
                  margin-right: -7px;
                }

                .progress-dot {
                  left: unset;
                  right: calc(75% + 11px);
                  transform: translate(50%, -50%);
                }

                .progress-trace {
                  .me {
                    right: unset;
                    left: 0;
                    transform: translate(-50%, -50%) rotateY(180deg);
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
